(function($){
	OH.settings.scalabelFigureDefine = (function(){
		var settings = {
			mapfigureTop : "/floor_map/",
			mapfigurePath : "/floor_map/images/",
      mapfigures: {
          1: "1f",
          2: "2f",
          3: "3f",
          4: "b1",
          5: "b2",
          6: "b3",
          7: "west",
          8: "dojunkan"
      },
      figname: {
          "default": "jp",
          ja: "jp",
          en: "en",
          "zh-CHS": "zh-CHS",//簡体中文
          "zh-CHT": "zh-CHT",//繁中
          // "zh-hant": "zh-hant",
          // "zh-hans": "c_map_01.png",
          ko: "ko"
      },
      pinPath: "/assets/images/floor_map/",
      pin4area: {
          none: "pin_omotesando.png",
          "default": "pin_omotesando.png",
          "本館1F": "pin_orange.png",
          "本館2F": "pin_orange.png",
          "本館3F": "pin_orange.png",
          "本館B1F": "pin_red.png",
          "本館B2F": "pin_red.png",
          "本館B3F": "pin_red.png",
          "西館1F": "pin_navy.png",
          "西館B1F": "pin_navy.png",
          "西館B2F": "pin_navy.png",
          "同潤館1F": "pin_green.png",
          "同潤館2F": "pin_green.png",
          "同潤館3F": "pin_green.png"
      },
			pinSize : {
				width : 51,
				height : 65,
				offsetX : 0,
				offsetY : 11
			},
			locationIcon : '<svg class="is-small c-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#map-marker"></use></svg>',
			topflow : {
				href : "/floor_map/",
				text : "フロアマップTOP"
			}
		};
		
		return settings;
	})();
})(jQuery);
